import { BaseAction } from '../../store/actions';
import { UserPasswordPayload, UserInfo, UserPayload } from '../../shared/models/user';

export enum UserManagementActions {
  LoadUserInfo = '[User] Load User Info',
  LoadUserInfoSucceed = '[User] Load User Info Succeed',
  LoadUserInfoFailed = '[User] Load User Info Failed',
  LoadUsers = '[User] Load Users',
  LoadUsersSucceed = '[User] Load Users Succeed',
  LoadUsersFailed = '[User] Load Users Failed',
  RemoveUsers = '[User] Remove Users',
  RemoveUsersSucceed = '[User] Remove Users Succeed',
  RemoveUsersFailed = '[User] Remove Users Failed',
  CreateUser = '[User] Create User',
  CreateUserSuccess = '[User] Create User Success',
  CreateUserFailed = '[User] Create User Failed',
  UpdateUser = '[User] Update User',
  UpdateUserSuccess = '[User] Update User Success',
  UpdateUserFailed = '[User] Update User Failed',
  ResetUserPassword = '[User] Reset User Password',
  ResetUserPasswordSuccess = '[User] Reset User Password Success',
  ResetUserPasswordFailed = '[User] Reset User Password Failed',
  ResetUpdateUserState = '[User] Reset Update User State',
  LoadUserForUpdate = '[User] Load User for Update',
  LoadUserForUpdateSuccess = '[User] Load User for Update Success',
  LoadUserForUpdateFailed = '[User] Load User for Update Failed',

  ReInviteUser = '[User] Reinvite User',
  ReInviteUserSuccess = '[User] Reinvite User Success',
  ReInviteUserFailed = '[User] Reinvite User Failed',

  MigrateUser = '[User] Migrate User',
  MigrateUserSuccess = '[User] Migrate User Success',
  MigrateUserFailed = '[User] Migrate User Failed',
}

export class LoadUserInfo implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUserInfo;

  constructor(public readonly payload: number) { }
}

export class LoadUserInfoSucceed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUserInfoSucceed;

  constructor(public readonly payload: UserInfo) { }
}

export class LoadUserInfoFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUserInfoFailed;

  constructor(public readonly payload: string) { }
}

export class LoadUsers implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUsers;

  constructor(public readonly payload: {
    orgId: number,
    includeChildren?: boolean
  }) { }
}

export class LoadUsersSucceed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUsersSucceed;

  constructor(public readonly payload: UserInfo[]) { }
}

export class LoadUsersFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUsersFailed;

  constructor(public readonly payload: string) { }
}

export class RemoveUsers implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.RemoveUsers;

  constructor(public readonly payload: {
    ids: string[],
    includeChildren: boolean
  }) { }
}

export class RemoveUsersSucceed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.RemoveUsersSucceed;
}

export class RemoveUsersFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.RemoveUsersFailed;

  constructor(public readonly payload: string) { }
}

export class CreateUser implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.CreateUser;

  constructor(public readonly payload: {orgId: number, body: UserPayload, includeChildren: boolean}) { }
}

export class CreateUserSuccess implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.CreateUserSuccess;

  constructor(public readonly payload: UserInfo) { }
}

export class CreateUserFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.CreateUserFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateUser implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.UpdateUser;

  constructor(public readonly payload: {userId: number, body: UserPayload}) { }
}

export class UpdateUserSuccess implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.UpdateUserSuccess;

  constructor(public readonly payload: UserInfo) { }
}

export class UpdateUserFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.UpdateUserFailed;

  constructor(public readonly payload: string) { }
}

export class ResetUserPassword implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ResetUserPassword;

  constructor(public readonly payload: {userId: number, body: UserPasswordPayload}) { }
}

export class ResetUserPasswordSuccess implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ResetUserPasswordSuccess;

  constructor(public readonly payload: UserInfo) { }
}

export class ResetUserPasswordFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ResetUserPasswordFailed;

  constructor(public readonly payload: string) { }
}


export class ResetUpdateUserState implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ResetUpdateUserState;
}

export class LoadUserForUpdate implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUserForUpdate;

  constructor(public readonly payload: number) { }
}

export class LoadUserForUpdateSuccess implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUserForUpdateSuccess;

  constructor(public readonly payload: UserInfo) { }
}

export class LoadUserForUpdateFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.LoadUserForUpdateFailed;

  constructor(public readonly payload: string) { }
}

export class ReInviteUser implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ReInviteUser;

  constructor(public readonly userId: number) { }
}

export class ReInviteUserSuccess implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ReInviteUserSuccess;
}

export class ReInviteUserFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.ReInviteUserFailed;

  constructor(public readonly payload: string) { }
}

export class MigrateUser implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.MigrateUser;

  constructor(public readonly payload: {
    userId: number,
    orgId: number,
  } ) { }
}

export class MigrateUserSuccess implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.MigrateUserSuccess;

  constructor(public readonly payload: any ) { }
}

export class MigrateUserFailed implements BaseAction<UserManagementActions> {
  readonly type = UserManagementActions.MigrateUserFailed;

  constructor(public readonly payload: string ) { }
}


export type UserManagementAction = LoadUserInfo | LoadUserInfoSucceed | LoadUserInfoFailed
  | LoadUsers | LoadUsersSucceed | LoadUsersFailed
  | RemoveUsers | RemoveUsersSucceed | RemoveUsersFailed
  | CreateUser | CreateUserSuccess | CreateUserFailed | ResetUpdateUserState
  | UpdateUser | UpdateUserSuccess | UpdateUserFailed
  | ResetUserPassword | ResetUserPasswordSuccess | ResetUserPasswordFailed
  | LoadUserForUpdate | LoadUserForUpdateSuccess | LoadUserForUpdateFailed
  | ReInviteUser | ReInviteUserSuccess | ReInviteUserFailed
  | MigrateUser | MigrateUserSuccess | MigrateUserFailed;
